import type { Translations } from '~/translations/Model'

const nb: Translations = {
  aschehoug: 'Aschehoug',
  application: 'Aunivers',
  reset: 'Start på nytt',
  next: 'Neste',
  previous: 'Forrige',
  of: 'av',
  loading: 'Laster...',
  logout: 'Logg ut',
  back: 'Tilbake',
  backTo: 'Tilbake til {name}',
  backToQuote: 'Tilbake til «{name}»',
  save: 'Lagre',
  cancel: 'Avbryt',
  error: 'Noe gikk galt!',
  jumpToContent: 'Hopp til hovedinnhold',
  help: 'Hjelp',
  resource: 'Ressurs',
  resourceCenter: 'Åpne hjelpesenter',
  close: 'Lukk',
  open: 'Åpne',
  download: 'Last ned',
  downloadIn: 'Last ned ({in})',
  visitIn: 'Besøk {in}',
  recommendedContent: 'Foreslått innhold',
  remove: 'Fjern',
  unknownError: 'Noe gikk galt dessverre. Prøv igjen senere.',
  noneSelected: 'Ingen valgt',
  relatedContent: 'Relatert innhold',
  new: 'Nytt',
  beta: 'Beta',
  newShort: 'Ny',
  coming: 'Kommer',
  preview: 'Forhåndsvis',
  breadcrumbs: 'Brødsmulesti',
  copyrightBtn: 'Opphavsrett',
  teacher: 'Lærer',
  clear: 'Nullstill',
  offline: 'Ingen internettforbindelse',
  readMoreAt: 'Les mer her',
  closeDialog: 'Lukk dialog',
  dialogDescription: 'Dialogvindu for {title}',
  copyCode: 'Kopier kode',
  credit: 'Kreditering',
  bookCorrections: 'Rettelser til boka',
  filesForDownload: 'Filer til nedlasting',
  login: {
    slogan: 'Med læreren. For eleven.',
    title: 'Logg inn',
    welcome: 'Velkommen til Aunivers',
    intro: 'For å se læremidlene må du logge inn',
    withServiceProvider: 'Med Feide',
    withLocalProvider: 'Logg inn uten Feide',
    logout: 'Logg ut',
    news: 'Aktuelt',
    more: 'Mer om aunivers.no',
    trialHeading: 'Få gratis tilgang i 30 dager!',
    trialText: 'Bestill prøvelisens og test ut alt vårt faginnhold samt plussproduktet Biblioteket, helt gratis!',
    trialCta: 'Prøv gratis',
    error: {
      title: 'Feil ved innlogging',
      unknown: 'Noe gikk galt i våre systemer. Vennligst prøv igjen.',
    }
  },
  time: {
    week: 'Uke',
    weekWithNumber: 'Uke {number}',
    relative: {
      recently: 'Nylig',
      today: 'I dag',
      yesterday: 'I går',
      thisWeek: 'Denne uken',
      lastWeek: 'Forrige uke',
      minutesAgo: 'for {n} minutter siden',
      hoursAgo: 'for {n} timer siden',
      daysAgo: 'for {n} dager siden',
    },
  },
  http: {
    404: {
      code: '404',
      message: 'Ikke funnet',
    },
  },
  notFound: {
    title: 'Finnes ikke',
    heading: 'Ooops!',
    message: 'Innholdet kan være fjernet, eller du kan mangle tilgang.',
    buttonText: 'Tilbake til forsiden',
    statusCode: 'Statuskode: {code}',
  },
  calendar: {
    title: 'Kalender',
    messages: {
      noResults: 'Ingen resultater',
      noResultsInWeekSwitcher: {
        message: 'Ingen oppgaver planlagt i uke {number} for {grade}',
        solution: 'Prøv å bytte gruppe, trinn eller uke. Legg til ved å trykke på \'Se flere oppgaver\'',
      },
      noResultsDescription: 'Fant ingen uker med innhold i valgt periode',
      noWeekResources: 'Fant ingen ressurser denne uken',
      noResourcesInPeriod: 'Fant ingen ressurser i valgt periode.',
      periodUpdated: 'Periode oppdatert',
      periodUpdateError: 'Kunne ikke oppdatere periode',
      periodCreated: 'Periode opprettet',
      periodCreateError: 'Kunne ikke opprette periode',
    },
    updatePlan: {
      titlePlaceholder: 'Tittel',
      bodyPlaceholder: 'Beskrivelse',
      dialogTitle: 'Rediger periode',
      save: 'Lagre',
      change: 'Rediger',
      cancel: 'Avbryt',
      delete: 'Slett',
    },
    createPeriod: {
      titlePlaceholder: 'Tittel',
      bodyPlaceholder: 'Beskrivelse',
      new: 'Ny periode',
      dialogTitle: 'Opprett periode',
      startWeek: 'Start-uke',
      endWeek: 'Slutt-uke',
      create: 'Opprett',
      abort: 'Avbryt',
      delete: 'Slett',
    },
    note: {
      teacher: 'Skriv notat',
      studentShow: 'Se notat fra lærer',
      studentHide: 'Skjul notat fra lærer',
    },
    yearPlan: {
      sharedYearPlans: 'Kollegers planer',
    },
    errors: {
      loadYearPlans: 'Noe gikk galt ved lasting av årsplaner',
      loadSharedYearPlans: 'Noe gikk galt ved lasting av foreslåtte årsplaner',
      loadPlans: 'Noe gikk galt ved lasting av planer',
    },
  },
  groups: {
    groups: 'Grupper',
    removeSelectedGroup: 'Fjern gruppevalg',
    active: 'Aktiv',
    activeTitle: 'Aktiv gruppe',
    title: 'Ingen klasse valgt | {count} klasser valgt',
    dialogBody: 'Velg hvilket fag og trinn du planlegger for.',
    missingSubject: 'Gruppen mangler et tilkoblet fag',
    confirmData: 'Bekreft fag og trinn',
    readOnlyBody: 'Gruppen er koblet til {grade}. For å endre, ta kontakt med {admins}',
    noGrades: 'Ingen trinn funnet',
    noSubjects: 'Ingen fag funnet',
    saveGroup: 'Lagre gruppe',
    editGroup: 'Rediger',
    deleteGroup: 'Slett',
    newGroup: 'Ny gruppe',
    noGroup: 'Mangler aktiv gruppe',
    chooseGroup: 'Velg en aktiv gruppe i toppmenyen for å se planlagte ressurser.',
    cancel: 'Avbryt',
    noSave: 'Gå til fagside',
    saveError: 'Feil ved lagring av gruppe',
    saveSuccess: 'Gruppen ble lagret',
    createSuccess: 'Gruppen «{name}» ble opprettet',
    nonWriteable: 'Grupper fra Feide kan ikke redigeres i Aunivers',
    nonAdminGroup: 'For å endre på gruppen må du ta kontakt med en administrator',
    nonAdminContact: 'For å endre på gruppen må du ta kontakt med {admins}',
    membersCount: '{count} medlemmer',
    members: 'Medlemmer',
    addMember: 'Legg til medlem i gruppen',
    addMemberShort: 'Legg til',
    removeMember: 'Fjern medlem fra gruppen',
    grade: 'Trinn',
    groupName: 'Gruppenavn',
    types: {
      basis: 'Klasser (Hentet fra Feide)',
      teaching: 'Undervisningsgrupper',
      other: 'Grupper (Laget i Aunivers)',
    },
    userSearch: {
      search: 'Søk etter brukere',
      searching: 'Søker...',
      noResults: 'Ingen resultater',
      error: 'Noko gjekk gale',
      placeholder: 'Søk etter elever eller lærere...',
    },
    groupDeleted: 'Gruppen ble slettet',
    groupDeleteError: 'Feil ved sletting av gruppe',
    noGradesConnected: 'Ingen tilkoblede trinn eller fag',
    admin: 'Lærer',
    groupDeleteConfirm: 'Er du sikker på at du vil slette denne gruppen?',
    groupNamePlaceholder: 'Skriv gruppenavn...',
    noLocalGroups: 'Du har ingen Aunivers grupper enda. <br> Trykk på "Ny gruppe" for å lage en.',
    noGroups: 'Du har ingen klasser eller grupper tilkoblet din bruker. Begynn å lage grupper enten i Feide eller ved å trykke "Ny gruppe" nedenfor.',
    noGroupsTitle: 'Mangler grupper',
    copyGroup: 'Kopier',
    copyOf: '{groupName} (kopi)',
  },
  header: {
    chooseGroup: 'Velg gruppe',
    showMenu: 'Vis sidemeny',
    notFound: 'Ingen ressurser funnet for {grade}',
    teacherGuide: {
      teacherGuide: 'Lærerveiledning',
      teacherGuideFor: 'Lærerveiledning: {title}',
      tip: 'Tips',
    },
  },
  settings: {
    title: 'Innstillinger',
    roleTeacher: 'Lærer hos',
    roleStudent: 'Elev ved',
    roleAtOrganization: '{role} {organization}',
    updated: 'Innstillinger lagret!',
    activeGroup: 'Du har en aktiv gruppe ({groupName})',
    missingGrade: 'Gruppen din mangler et tilkoblet trinn',
    missingSubject: 'Gruppen din mangler et tilkoblet fag',
    changeSubjectInfo: 'Du kan fortsatt redigere hvilke fag du vil ha synlig på forsiden!',
    groupInfo: 'Grupper gjør det enklere å navigere riktig innhold! Derfor krysser vi automatisk av på innstillingene nedenfor basert på trinn og fag koblet til din gruppe',
    chooseGrade: 'Velg skoleslag for å se relaterte fag',
    chooseGradeToClose: 'Du må velge et skoleslag',
    chooseGradeType: 'Velg et skoleslag',
    gradeTypeWarning: 'Noe er ikke helt riktig. Trykk på "Innstillinger" for å velge ditt skoleslag.',
    readOnlyGradesSpansAcrossgradeTypes: {
      title: 'Feide-trinn på tvers av skoleslag',
      info: 'Dine Feide-trinn dekker flere skoleslag. Alle valgte trinn vises når du velger skoleslag, og bytter du skoleslag, blir trinnene for det skoleslaget også tilgjengelige i Aunviers, sammen med trinnene fra Feide.',
    },
    sections: {
      display: 'Visningsvalg',
      gradeType: 'Skoleslag',
      language: 'Målform',
      instruction: 'Undervisning',
      tts: 'Talesyntese',
    },
    drawers: {
      customization: 'Fag og skoleslag',
      language: 'Språk',
      groups: 'Klasser og grupper',
      plans: 'Foreslåtte planer',
      licenses: 'Lisenser',
      shortcuts: 'Snarveier',
      subscription: 'Abonnement',
    },
    shortcuts: {
      digitalBooks: 'Unibok - Digitale bøker',
      oldContent: 'Innhold fra Lokus (LK-06)',
    },
    vgsWeirdness: {
      cantRemoveLastSelected: 'Du kan ikke fjerne det siste valgte trinnet. Velg heller et annet skoleslag.',
    },
  },
  wizard: {
    warningTitle: 'Vent litt!',
    warningText: 'Velg både skoleslag og fag før du lukker vinduet.',
    nextStep: 'Neste',
    prevStep: 'Forrige',
    step: 'Steg {activeStep} av {steps}',
    finish: 'Fullfør',
    grades: 'Velg hvilket skoleslag du underviser på',
    subjects: 'Hvilke fag ønsker du å se?',
    language: 'Velg foretrukket målform',
  },
  licenses: {
    title: 'Lisenser',
  },
  home: {
    title: 'Hjem',
    welcome: 'Velkommen til Aunivers!',
    yourSubjects: 'Dine fag',
    yourProducts: 'Dine produkter',
    yourAddons: 'Dine tilleggsprodukter',
    showMoreSubjects: 'Vis flere fag',
    showLessSubjects: 'Vis færre fag',
    showMoreProducts: 'Vis flere produkter',
    showLessProducts: 'Vis færre produkter',
    didYouKnow: 'Visste du at:',
    greetings: {
      morning: 'God morgen',
      afternoon: 'God ettermiddag',
      evening: 'God kveld',
      night: 'God natt',
    },
  },
  notifications: {
    title: 'Varsler',
    notification: 'Varsel',
    today: 'I dag',
    thisWeek: 'Siste syv dager',
    markRead: 'Marker som lest',
    markAllRead: 'Marker alle som lest',
    allNotifications: 'Alle varsler',
    allNotificationsMarkedAsRead: 'Alle varsler ble markert som lest',
    sentNotifications: 'Sendte varsler',
    receivedNotifications: 'Mottatte varsler',
    noNotifications: 'Hurra! Du har ingen nye varsler',
    noReceivedNotifications: 'Du har ingen nye mottatte varsler',
    noSentNotifications: 'Du har ikke sendt varsler nylig',
    chooseNotificationType: 'Velg type varsel',
    viewAll: 'Se alle',
    goToResource: 'Gå til ressurs',
    received: 'Mottatt',
    sent: 'Sendt',
  },
  metadata: {
    weekdays: {
      monday: 'Mandag',
      tuesday: 'Tirsdag',
      wednesday: 'Onsdag',
      thursday: 'Torsdag',
      friday: 'Fredag',
      saturday: 'Lørdag',
      sunday: 'Søndag',
    },
    subscriptionGrades: {
      '1-7': '1–7',
      '8-10': '8–10',
      'vgs': 'VGS',
    },
    gradeTypes: {
      grade1to4: 'Barneskole 1-4',
      grade5to7: 'Barneskole 5-7',
      grade8to10: 'Ungdomsskole',
      gradeVgs: 'Videregående',
      gradeAdult: 'Voksen',
      gradePrep: 'Forkurs',
      short: {
        grade1to4: '1–4',
        grade5to7: '5–7',
        grade8to10: '8–10',
        gradeVgs: 'Videregående',
        gradeAdult: 'Voksen',
        gradePrep: 'Forkurs',
      }
    },
    grades: {
      aarstrinn1: 'Trinn 1',
      aarstrinn2: 'Trinn 2',
      aarstrinn3: 'Trinn 3',
      aarstrinn4: 'Trinn 4',
      aarstrinn5: 'Trinn 5',
      aarstrinn6: 'Trinn 6',
      aarstrinn7: 'Trinn 7',
      aarstrinn8: 'Trinn 8',
      aarstrinn9: 'Trinn 9',
      aarstrinn10: 'Trinn 10',
      vg1: 'Vg1',
      vg2: 'Vg2',
      vg3: 'Vg3',
      vok: 'Voksen',
      prep: 'Forkurs',
      forkurs: 'Forkurs',
    },
    gradesPunctuated: {
      aarstrinn1: '1. trinn',
      aarstrinn2: '2. trinn',
      aarstrinn3: '3. trinn',
      aarstrinn4: '4. trinn',
      aarstrinn5: '5. trinn',
      aarstrinn6: '6. trinn',
      aarstrinn7: '7. trinn',
      aarstrinn8: '8. trinn',
      aarstrinn9: '9. trinn',
      aarstrinn10: '10. trinn',
      vg1: 'Vg1',
      vg2: 'Vg2',
      vg3: 'Vg3',
      vok: 'Voksenopplæring',
      forkurs: 'Forkurs',
      prep: 'Forkurs',
    },
    gradesShort: {
      aarstrinn1: '1.',
      aarstrinn2: '2.',
      aarstrinn3: '3.',
      aarstrinn4: '4.',
      aarstrinn5: '5.',
      aarstrinn6: '6.',
      aarstrinn7: '7.',
      aarstrinn8: '8.',
      aarstrinn9: '9.',
      aarstrinn10: '10.',
      vg1: 'vg1',
      vg2: 'vg2',
      vg3: 'vg3',
      vok: 'vok',
      forkurs: 'Forkurs',
      prep: 'forkurs',
    },
    subjects: {
      ENG: 'Engelsk',
      FSP: 'Fremmedspråk',
      KRO: 'Kroppsøving',
      MAT: 'Matematikk',
      NAT: 'Naturfag',
      FLE: 'Flerfaglig',
      NOR: 'Norsk',
      SAF: 'Samfunnsfag',
      FYS: 'Fysikk',
      GEO: 'Geografi',
      HEL: 'Helse',
      HIS: 'Historie',
      KJE: 'Kjemi',
      MED: 'Mediefag',
      POL: 'Politikk',
      PSY: 'Psykologi',
      REL: 'Religion og etikk',
      KRL: 'KRLE',
      TVE: 'Året rundt',
      INF: 'Informasjonsteknologi',
      SPA: 'Spansk',
      TYS: 'Tysk',
      FRA: 'Fransk',
      GFG: 'Geofag',
      KHV: 'Kunst og håndverk',
      MUS: 'Musikk',
      MHE: 'Mat og helse',
      SOK: 'Sosialkunnskap',
      SOS: 'Sosiologi og sosialantropologi',
      POM: 'Politikk og menneskerettigheter',
      SAK: 'Samfunnskunnskap',
      SAG: 'Samfunnsgeografi ',
      LANG: 'Språkfag',
      REAL: 'Realfag',
      TST: 'Under utvikling',
    },
    language: {
      title: 'Målform',
      nb: 'Bokmål',
      nn: 'Nynorsk',
    },
    taskTypes: {
      article: 'Artikkel',
      video: 'Video',
      audio: 'Lyd',
      file: 'Fil',
      document: 'Dokument',
      task: 'Oppgave',
      resource: 'Ressurs',
      digitalbook: 'Digitalbok',
      game: 'Spill',
    },
  },
  organization: {
    title: 'Velg en aktiv skole for din økt',
    choose: 'Velg skole',
  },
  filters: {
    forTeacher: 'Til lærer',
    content: 'Innhold',
    emptyFilter: 'Tøm filter',
    chooseTheme: 'Velg tema',
    chooseTaskType: 'Velg innholdstype',
    chooseSubject: 'Velg fag',
    chooseGrade: 'Velg trinn',
    chooseGradeType: 'Velg skoleslag',
    chooseGroup: 'Velg gruppe',
    chooseLanguage: 'Velg målform',
    chooseFilters: 'Vis filtre',
    hideFilters: 'Skjul filtre',
    chooseSorting: 'Velg sortering',
    chooseProduct: 'Velg bok',
    chooseWeekNumber: 'Velg uke',
    chooseHeader: 'Velg tema',
    chooseSchoolYear: 'Velg skoleår',
    noResourcesFound: 'Ingen ressurser funnet',
    noProducts: 'Ingen bøker funnet',
    noSubjects: 'Ingen fag funnet',
    toLegacySubject: 'Gammelt oppsett',
    toNewSubject: 'Nytt oppsett',
    filteredAway: {
      title: 'Fant ingen ressurser',
      messageWithGrades: 'Du kan se innhold ved å bytte til følgende trinn:',
      messageWithGradeTypes: 'Du kan se innhold ved å bytte til følgende skoleslag:',
      messageWithoutGrades: 'Prøv å endre på filtreringen, eller ta kontakt med kundeservice',
    },
    subject: 'Fag',
    grade: 'Trinn',
    genre: 'Sjanger',
    product: 'Bok',
    header: 'Overskrift',
    taskType: 'Innholdstype',
    filterSettings: 'Visningsvalg',
    sortSettings: 'Sorteringsvalg',
    noHits: 'Oi! Ser ut som filteret ditt ikke har noen treff.',
    trySomethingElse: 'Prøv andre kombinasjoner for å få flere resultater.',
    frontpage: 'Forside {subjectName}',
    settings: {
      suggested: 'Foreslått rekkefølge',
      alphabetical: 'Alfabetisk',
      studentActivity: 'Siste elevaktivitet',
      random: 'Tilfeldig sortering',
    },
    values: {
      allSubjects: 'Alle fag',
      allGroups: 'Alle grupper',
      thisWeek: 'Denne uken',
      wholeClass: 'Hele klassen',
      week: {
        previous: 'Forrige uke',
        current: 'Denne uken',
        next: 'Neste uke',
        previousFourWeeks: 'Siste fire uker',
        previousThreeMonths: 'Siste tre måneder',
        fromSchoolYearStart: 'Siden skolestart',
        yearplan: 'Se årsplan',
      },
    },
  },
  favorite: {
    list: 'Liste',
    favoriteListsPageTitle: 'Lister',
    favoriteListsViewTitle: 'Mine lister',
    save: 'Legg i liste',
    counted: 'Ingen ressurser | 1 ressurs | {number} ressurser',
    addToList: 'Legg i liste',
    addToListSuccess: 'Lagt til i listen',
    createListDialogTitle: 'Ny liste',
    createListButtonName: 'Opprett ny liste',
    favoriteListsBackButton: 'Mine lister',
    favoriteListDropdownLabel: 'Velg liste',
    createListNameLabel: 'Gi listen et navn',
    createSuccess: 'Ny liste opprettet',
    deleteSuccess: 'Listen ble slettet',
    deleteList: 'Slett listen',
    removeFromList: 'Fjern fra listen',
    removedItemFromListSuccess: '«{name}» fjernet fra {listName}',
    deleteConfirmationText: 'Vil du virkelig slette «{name}»?',
    editListDialogTitle: 'Endre navn/notat',
    editListNameLabel: 'Gi listen et nytt navn',
    editListNoteLabel: 'Skriv et notat for listen (valgfritt)',
    editListInfo: 'Endre navn',
    noneCounted: 'Ingen ressurser',
    ownedByMe: 'Min liste',
    ownedBySomeoneElse: 'Noen andre sin liste',
    sharedWithMe: '{name} har delt listen med deg',
    browseList: 'Bla i listen',
    copyUrl: 'Kopier URL',
    delete: 'Slett',
    updateSuccess: 'Lagret',
    copySuccess: 'Kopiert',
    copyFailure: 'Kunne ikke kopiere URL',
    navigation: 'Navigasjon i liste',
    navigationDots: 'Liste med ressurser',
    rearrange: 'Trykk pil opp eller ned for å endre rekkefølgen',
    messageFrom: 'Melding fra: <b>{name}</b>',
    duplicateList: 'Dupliser',
    duplicateConfirm: 'Bekreft',
    duplicateViewSuccess: 'Listen ble duplisert, og du ser nå på din nye liste',
    duplicateSuccess: 'Listen ble duplisert',
    duplicateConfirmationText: 'Ønsker du å duplisere denne listen?',
    sharedWith: 'Delt med',
    addLink: 'Legg til lenke',
    linkName: 'Navn på lenken (valgfritt)',
    missingUrl: 'Mangler gyldig URL',
    linkFailure: 'Feil ved oppretting av lenken',
    fileNotFound: 'Filen ble ikke funnet',
    uploadFailure: 'Feil ved opplasting av filen',
    nameTooShort: 'Navn er fort kort',
    fileFailure: 'Feil ved oppretting av filen',
    visitLink: 'Besøk lenken på {host}',
    limitShort: 'Maksgrense nådd',
    limitReached: 'Maksgrensen på {limit} stk er nådd',
    externalLink: 'Ekstern lenke',
    editFavorite: 'Endre navn',
    editSuccess: 'Ressursen ble oppdatert',
    editFailure: 'Noe gikk galt',
    notFound: 'Ikke funnet',
    note: 'Notat',
  },
  plans: {
    plan: 'Plan',
    plannedThisWeek: 'Planlagt denne uka',
    allPlans: 'Alle planer',
    allYears: 'Alle år',
  },
  plan: {
    title: 'Planlagt',
    content: 'Planlagt innhold',
    add: 'Legg i plan',
    sharePlan: 'Knytt til gruppe',
    copySelection: 'Kopieringsvalg',
    copyYearPlan: 'Kopier plan',
    deleteYearPlan: 'Slett plan',
    copyYearPlanToGroup: 'Kopier ressurser',
    copyYearPlanToGroupExplanation: 'Dette vil kopiere ressursene som er delt med {groupName} i {weekNumber} til en annen gruppe.',
    chooseGroupToCopyTo: 'Velg gruppe å kopiere ressurser til',
    noPlans: 'Fant ingen planlagte ressurser i {subject} i {weekNumber}',
    goToResources: 'Gå til fagsiden for {subject}',
    resourcesCopied: 'Ressursene ble kopiert til {groupName}',
  },
  yearPlan: {
    plural: 'Planer',
  },
  learningPath: {
    learningPathOverview: 'Åpne oversikt over læringsløp',
    learningPathParts: '{partsCount} deler',
    noResourcesFound: 'Fant ingen ressurser i læringsløpet',
  },
  links: {
    seeAll: 'Se alle',
    viewTasks: 'Se ukens planlagte ({number})',
    viewMoreTasks: 'Tilbake til fagside',
    loadingTasks: 'Laster ukens planlagte',
  },
  contentTypes: {
    default: 'Ressurs',
    resource: 'Ressurs',
    folder: 'Mappe',
    product: 'Produkt',
    product_container: 'Oversikt',
    product_article: 'Artikkel',
    product_package: 'Innholdspakke',
    product_header: 'Tema',
    product_tailor: 'Ressurs',
    product_part: 'Del',
    part: 'Del av læringsløp',
    product_colophon: 'Kolofon',
    article: 'Artikkel',
    learning_path: 'Læringsløp',
    document: 'Dokument',
    landing_page: 'Forside',
    cloubi_content: 'Ressurs',
    video: 'Video',
    image: 'Bilde',
    upload_video: 'Video',
    activetextbook: 'Interaktiv bok',
    drawing_tool: 'Tavleressurs',
    file: 'Fil',
    audio: 'Lyd',
    svg: 'Bilde',
    game_board: 'Spillbrett',
    game_part: 'Øve',
    form_writer: 'Innlevering',
    epub: 'E-bok',
    link: 'Lenke',
    literary_text: 'Litterær tekst',
    peer_gynt: 'Spill',
    upload_file: 'Opplasting',
    book_reader: 'Bokleser',
    presentation: 'Presentasjon',
    flyt_task: 'Oppgave',
    task: 'Oppgave',
    pdf_book: 'Digitalbok',
    digitalbook: 'Digitalbok',
    game: 'Spill',
    cloubi: 'Ressurs',
    blog_post: 'Blogginnlegg',
    guide: 'Til lærer',
    model3d: '3D-Modell',
    image_360: '360-Bilde',
    image_collection: 'Bildesamling',
    reading_aid: 'Lesehjelper',
    colophon: 'Kolofon',
    app_article: 'Tekst',
    app_article_teacher: 'Til lærer',
    flashcard_deck: 'Flashcards',
    chatbot: 'Chatbot',
    scene: 'Scene',
    theme: 'Tema',
    conversation: 'Samtale',
  },
  sections: {
    none: 'Mangler innhold til dine trinn og fag. Prøv å endre på innstillingene.',
    teacherResources: 'Lærerressurser for {subject}, {grade}',
  },
  dialog: {
    confirm: 'OK',
    cancel: 'Avbryt',
    choose: 'Velg',
    create: 'Opprett ny',
    add: 'Legg til',
    on: 'På',
    off: 'Av',
  },
  copy: {
    copyUrl: 'Kopier lenke',
    copyTemplate: {
      title: 'Uke {weekNumber}',
    },
    messages: {
      success: 'Kopiert',
      error: 'Kunne ikke kopiere',
    },
  },
  footer: {
    customerService: 'Kundeservice',
    whitelist: 'Hvitlisting',
    privacy: 'Personvern',
    accessibility: 'Universell utforming',
    webshop: 'Nettbutikk',
    copyright: 'Rettigheter',
    cookies: 'Cookies',
  },
  trial: {
    title: 'Velkommen!',
    message: 'Her finner du innhold til alle fag og alle trinn. <a href="{href}" target="_blank">Bestill en gratis prøvelisens</a> til vårt utforskende læringsunivers. God lærelyst!',
    noHits: 'Husk at du kan <a href="{href}" target="_blank">bestille en gratis prøvelisens</a> til vårt utforskende læringsunivers.',
  },
  license: {
    message: 'Lisensdetaljer for {name}',
    ean: 'ISBN',
    licenseModel: 'Type',
    endDate: 'Gyldig til',
    orderId: 'Ordrenr',
    usageRights: 'Antall',
    noLicenses: {
      title: 'Fant ingen lisenser',
      message: 'Om du tror dette er en feil kan du forsøke å laste inn siden på nytt eller kontakte kundestøtte.'
    }
  },
  licenseModel: {
    OPEN: 'Åpen lisens',
    SCHOOL: 'Skolelisens',
    INDIVIDUAL: 'Enkeltlisens',
    PRIVATE: 'Privatlisens',
    TRIAL_SCHOOL: 'Prøvelisens, skole'
  },
  colophon: {
    title: 'Om {subject}',
    plural: 'Kolofoner',
    back: 'Tilbake til fagside',
    notFoundSubject: 'Ingen kolofoner funnet for {subject} i {grade}',
    notFoundLocation: 'Ingen kolofon funnet',
  },
  search: {
    title: 'Søk',
    placeholder: 'Søk her...',
    lookingFor: 'Søk innenfor {filters}...',
    globalSearch: 'Søk i hele Aunivers',
    resultsCount: '{count} treff',
    currentPage: 'Side {page} av {totalPages}',
    noResults: 'Ingen resultater funnet',
    noResultsDescription: 'Fant ingen søkeresultater som samsvarer med søkeordet eller filtrene dine.',
    spellingSuggestion: 'Mente du',
    searchingIn: 'Søker i {in}',
    loadingProducts: 'Stiller inn søket',
    failed: 'Noe gikk galt',
    reset: 'Nullstill',
    resetSearch: 'Start på nytt',
    resetFilters: 'Fjern alle filtre',
    contentTypes: 'Innholdstyper',
    animationLabel: 'Animert illustrasjon som illustrerer et søk',
    popularSearches: 'Populære søkeord',
    subject: 'Søk i {subject}',
    subjectAll: 'Søk i alle {subject} ressurser',
    settings: {
      mySettings: 'Om søket',
      grade: 'Trinninnstillinger',
      results: 'Du får resultater basert på disse bøkene',
      editMessage: 'Du kan redigere trinnene dine i <b>Innstillinger > Trinn og fag</b>',
    },
    lockedContent: {
      noAccess: 'Du har ikke tilgang til dette innholdet',
      goToWebshop: 'Gå til nettbutikken',
      relatedProduct: 'Dette innholdet hører til produktet <b>{product}</b>.',
      unknownProduct: 'Dette innholdet hører til et produkt som er lisensbelagt.',
      findTeacher: 'Du finner produktet i vår nettbutikk.',
      findStudent: 'Ta kontakt med læreren din hvis du forventet å ha tilgang.',
    },
    paginator: {
      page: 'Side {page}',
      nextPage: 'Neste side',
      prevPage: 'Forrige side',
      navigation: 'Sidenavigering',
    },
    filters: {
      showGradeFilter: 'Vis trinnfiltre',
      hideGradeFilter: 'Skjul trinnfiltre',
      showSubjectFilter: 'Vis fagfiltre',
      hideSubjectFilter: 'Skjul fagfiltre',
      activeFilters: 'Aktive filtre',
      removeFilter: 'Fjern {filter} som filter',
      removeAllFilters: 'Fjern alle filtre',
      filterBySubject: 'Filtrer på fag',
      allGrades: 'Alle trinn',
    },
    suggested: {
      one: 'Rettigheter',
      two: 'Bærekraftig utvikling',
      three: 'Demokrati',
      four: 'Samfunn',
      five: 'Identitet',
    },
    sortField: {
      sorting: 'Sortering',
      score: 'Mest relevant',
      modified: 'Nylig oppdatert',
      published: 'Nylig publisert',
    },
    checkboxes: {
      has_audio: 'Med lyd',
      has_more: 'Med opplegg',
      tiered: 'Nivådelt',
    },
    filterBoxes: {
      'target_group': 'Passer for',
      'theme': 'Tema',
      'genre': 'Sjanger',
      'series': 'Serie',
      'language': 'Språk',
      '1-4': 'Barneskole 1-4',
      '5-7': 'Barneskole 5-7',
      '8-10': 'Ungdomsskole',
      'vgs': 'Videregående',
      'voksen': 'Voksenopplæring',
      'forkurs': 'Forkurs',
      'support': 'Bok- og lydstøtte',
    },
    product: {
      back: 'Tilbake til {product}',
      placeholder: {
        Biblioteket: 'Søk i biblioteket etter tittel eller forfatter...',
        default: 'Søk her...',
      },
    }
  },
  register: {
    form: {
      title: 'Registrer ny bruker',
      intro: 'For å bruke digitale læremidler på Aunivers.no/unibok.no må du registrere deg.',
      submit: 'Registrer',
    },
    input: {
      firstName: 'Fornavn',
      lastName: 'Etternavn',
      email: 'E-postadresse',
      password: 'Ditt passord',
      terms: 'Jeg har lest, forstått og akseptert <a href="{url}" class="underline" target="_blank">brukervilkårene</a>'
    },
    invalid: {
      firstName: 'Fornavn er ikke gyldig',
      lastName: 'Etternavn er ikke gyldig',
      email: 'E-postadressen er ikke gyldig',
      password: 'Passordet er ikke gyldig',
    },
    error: {
      internal: 'Noe gikk galt ved registrering av brukeren. Vennligst prøv på nytt om en liten stund.',
      loggedIn: 'Du kan ikke registrere en bruker når du allerede er logget inn',
      invalidInput: 'Feil ved validering av dataene dine. Se over og prøv på nytt',
      alreadyExists: 'En bruker med samme e-postadresse eksisterer allerede',
      missingParams: 'Mangler nødvendig aktiveringskode',
      activate: 'Noe gikk galt ved aktivering av kontoen din',
    },
    success: {
      title: 'Vellykket registrering!',
      info: 'Brukeren din er registrert, men må bekreftes først. Dette må du gjøre nå:',
      confirm1: 'Åpne e-posten du har fått',
      confirm2: 'Klikk på lenken <b>innen to dager</b> for å aktivere brukeren din',
    },
    activate: {
      title: 'Aktivering',
      info: 'Lag et passord til brukeren din. Oppgi minst åtte tegn, inkludert minst ett tall.',
      inputText: 'Vis i klartekst',
      inputPassword: 'Skjul tekst',
      success: 'Passordet er lagret. Du kan nå logge inn.',
    },
  },
  access: {
    title: 'Tilgang',
    public: 'Åpen for alle',
    teacher: 'Kun for lærer',
  },
  mimeType: {
    pdf: 'PDF-fil',
    word: 'Word-fil',
    excel: 'Regneark',
    video: 'Video',
    audio: 'Lydfil',
    image: 'Bilde',
    powerpoint: 'Presentasjon',
    archive: 'Arkiv',
    file: 'Fil',
    python: 'Python-script',
    code: 'Kode',
    text: 'Tekst',
  },
  bookreader: {
    error: 'Kunne ikke laste inn bokleser',
    loading: 'Laster inn bokleser',
    readBook: 'Les bok',
  },
  flashcards: {
    error: 'Kunne ikke laste inn flashcards',
    tip: 'Trykk på kortene for å snu dem rundt.',
    start: 'Start',
    retry: 'Prøv på nytt',
    complete: 'Da var du igjennom!',
    stage: '{n} av {total}',
  },
  content: {
    published: 'Utgitt',
    language: 'Språk',
    pageCount: 'Antall sider',
    audio: 'Lyd',
    recordedAudio: 'Innlest lyd',
    inSeries: 'Inngår i serie',
  },
  presentation: {
    page: 'Side',
    pageNumber: 'Side {pageNumber}',
    pageNumberOfTotal: 'Side {pageNumber} / {totalPages}',
    teacherGuide: 'Lærerveiledning',
    menu: {
      menu: 'Meny',
      content: 'Innhold',
    },
  },
  article: {
    word: 'Ord',
    text: 'Tekst',
    toTeacher: 'Til lærer',
    toStudent: 'Veiledning',
    teacherGuide: 'Lærerveiledning',
    studentGuide: 'Veiledning',
    error: 'Noe gikk galt med å hente innholdet. Vennligst prøv igjen.',
    noContent: 'Mangler innhold ...',
    changeWidth: 'Endre bredde',
    asideOpen: 'Vis oppgaver',
    articleSub: 'Nivå {number}',
  },
  media: {
    playVideo: 'Spill av video',
    pauseVideo: 'Pause video',
    audioShort: 'Lytt',
    audioArticle: 'Lytt til teksten',
    playAudio: 'Spill av lyd',
    pauseAudio: 'Pause lyd',
    closeAudio: 'Lukk',
    loadingAudio: 'Laster inn lyd',
    retryingAudio: 'Venter på ny lydfil. Dette kan ta litt tid',
    showCopyright: 'Vis rettigheter',
    hideCopyright: 'skjul rettigheter',
    recordAudio: 'Lydopptak',
    recordingInProgress: 'Opptak pågår...',
    restartRecording: 'Start på nytt',
    startRecording: 'Spill inn lyd',
    stopRecording: 'Stopp opptak',
    pauseRecording: 'Pause opptak',
    continueRecording: 'Fortsett opptak',
    playRecording: 'Lydinnspilling klar',
    stopPlayingRecording: 'Stopp avspilling',
    saveRecording: 'Legg til innlevering',
    removeRecording: 'Slett innspilling',
    errorRecording: 'Noe gikk galt med lydopptaket',
    missingPlayer: 'Mangler lydavspiller',
    recordingMaxLength: 'Maks lengde: {minutes} min',
    errorNotAllowed: 'Du har ikke tilgang til ressursen',
    errorNotFound: 'Ressursen er tom er ikke tilgjengelig',
    updateFilename: 'Endre navn',
    missingFilename: 'Tomt filtnavn',
    filenamePlaceholder: 'Skriv et navn...',
    editFileName: 'Rediger navn',
    fileIsTooLargeTitle: 'Maks filstørrelse',
    fileIsTooLargeText: 'Maksgrensen på {mb}MB er nådd. Kan du velge en mindre fil?',
    unknownError: 'Ukjent feil har oppstått',
    loading: 'Laster...',
    uploadFile: 'Last opp fil',
    downloadError: 'Ukjent feil ifm nedlastingen',
    uploadImage: 'Last opp bilde',
    uploading: 'Laster opp...',
    download: 'Last ned',
    downloadFile: 'Last ned {mimeType}',
    removeFile: 'Slett fil',
    uploadReady: '{fileType} lastet opp',
    changeSpeed: 'Endre hastighet',
    normalSpeed: 'Vanlig',
    nameFile: 'Gi filen et navn',
    editName: 'Rediger navn',
    writeNote: 'Skriv et notat...',
  },
  recordError: {
    aborted: 'Opptak avbrutt',
    notAllowed: 'Ingen tillatelse til å ta opp lyd',
    notFound: 'Fant ingen lydopptaksenhet',
    notReadable: 'Kan ikke lese fra lydopptaksenheten',
    notSupported: 'For å ta opp lyd, bruk nettlesere som Chrome og Firefox',
    security: 'Det oppstod en sikkerhetsfeil ved tilgang til lydopptaksenheten',
    type: 'Ugyldig type lydopptaksenhet',
    state: 'Lydopptaksenheten er i en ugyldig tilstand',
    unknown: 'Det oppstod en ukjent feil',
  },
  lottie: {
    play: 'Spill av animasjon',
    pause: 'Pause animasjon',
  },
  licenseControl: {
    message: {
      title: 'Du har ikke tilgang til dette innholdet',
      body: {
        teacher: 'Vi klarte ikke å finne en gyldig lisens på dette innholdet. Om du mener dette er en feil, kontakt kundestøtte for hjelp',
        student: 'Spør læreren din om hjelp',
      },
      product: {
        library: '<b>Biblioteket</b> er fullt av digitale bøker, skapt for å gi lesekompetanse og leseglede gjennom hele grunnskolen. Du finner bøker med innlest lyd, bøker på engelsk og populære serier.',
        paperPlus: '<b>Papir+</b> gir deg en mengde elevark med selvforklarende oppgaver i en rekke fag på 1.-7. trinn. Skriv ut og ta med rett inn i timen.',
        exam: '<b>Terminprøvene</b> kommer hver høst og vår i norsk, matematikk og engelsk for ungdomstrinnet. Her får du komplette løsningsforslag og prøver, i tillegg til støttemateriell. Du får mulighet til å tilpasse, endre og differensiere oppgavene slik at dine elever får en unik prøve.',
      },
      upgrade: {
        noSubscription: 'Du kan bestille prøvelisens.',
        trial: 'Du har prøvelisens. Lisens kan kjøpes i nettbutikken.',
        why: 'Abonnementet må oppgraderes for å få tilgang til Biblioteket/Papir+/Terminprøver',
        who: 'Snakk med din skoleleder om å oppgradere abonnementet skolen din har på Aunivers.',
      },
    },
    buttons: {
      back: 'Tilbake',
      webshop: 'Til nettbutikk',
      trial: 'Prøvelisens',
    },
  },
  fullscreen: {
    close: 'Lukk fullskjerm',
    open: 'Åpne fullskjerm',
  },
  pdfViewer: {
    downloadDisabled: 'Beklagar, men du kan ikkje lagre denne PDFen.',
  },
  labels: {
    product_article: 'Produktartikkel',
    learning_path: 'Læringsløp',
    file: 'Fil',
    product_part: 'Del av løp',
    video: 'Video',
    article: 'Artikkel',
    task: 'Oppgave',
    resource: 'Ressurs',
    digitalbook: 'Digitalbok',
    audio: 'Lyd',
    audio_transcription: 'Tekst',
    part: 'Del av løp',
    game: 'Spill',
    document: 'Dokument',
    documents: 'Dokumenter',
    book_reader: 'Bokleser',
    presentation: 'Presentasjon',
    other: 'Annet',
    app_teacher: 'Lærerveiledning',
    podcast: 'Podkast',
    essay: 'Fagtekst',
    activity: 'Aktivitet',
    map: 'Kart',
    print: 'Utskrift',
    fiction: 'Skjønnlitterær tekst',
    poem: 'Dikt',
    short: 'Novelle',
    experiment: 'Forsøk',
    pause: 'Avbrekk',
    text: 'Tekst',
    wimmelimage: 'Myldrebilde',
    teacher: 'Lærerveiledning',
    theme: 'Tema',
    package: 'Innholdspakke',
    recommended: 'Anbefalt',
    product: 'Produkt',
    chatbot: 'Chatbot',
    flashcards: 'Flashcards',
    subject_matter: 'Fagstoff',
    model_text: 'Modelltekst',
    summary: 'Sammendrag',
    grammar: 'Grammatikk',
    dialog: 'Dialog',
    scene: 'Scene',
    manipulatives: 'Konkreter',
    canvas: 'Lerret',
    teacher_guide: 'Lærerveiledning',
    text_comprehension: 'Tekstforståelse',
    assignment: 'Innlevering',
    form_writer: 'Skriveramme',
    chapter: 'Kapittel',
  },
  activities: {
    'messages': {
      title: 'Aktiviteter',
    },
    'bokstavoppdrag': 'Bokstavoppdrag',
    'bruke begrepene': 'Bruke begrepene',
    'diskutere': 'Diskutere',
    'forsøk': 'Forsøk',
    'gloser': 'Gloser',
    'gruble sammen': 'Gruble sammen',
    'huskesetning': 'Huskesetning',
    'interaktiv oppgave': 'Interaktiv oppgave',
    'ki-oppgave': 'KI-oppgave',
    'kladdebokoppgave': 'Kladdebokoppgave',
    'kulturkunnskap': 'Kulturkunnskap',
    'lage': 'Lage',
    'leke': 'Leke',
    'lese': 'Lese',
    'leseforståelse': 'Leseforståelse',
    'leseoppdrag': 'Leseoppdrag',
    'lyd': 'Lyd',
    'lytte': 'Lytte',
    'lyttetekst': 'Lyttetekst',
    'lære': 'Lære',
    'nøkkelord': 'Nøkkelord',
    'presentere': 'Presentere',
    'reflektere': 'Reflektere',
    'regne': 'Regne',
    'sammendrag': 'Sammendrag',
    'samtale': 'Samtale',
    'skrive': 'Skrive',
    'skriveoppgave': 'Skriveoppgave',
    'skriveramme': 'Skriveramme',
    'skrivestarter': 'Skrivestarter',
    'snakke': 'Snakke',
    'spill': 'Spill',
    'synge': 'Synge',
    'tankekart': 'Tankekart',
    'tematekst': 'Tematekst',
    'utforske': 'Utforske',
    'utskrift': 'Utskrift',
    'uttale': 'Uttale',
    'venndiagram': 'Venndiagram',
    'vgs': 'Vgs',
    'video': 'Video',
    'vurdering': 'Vurdering',
    'øve': 'Øve',
  },
  genre: {
    'romanutdrag': 'Romanutdrag',
    'fortelling': 'Fortelling',
    'novelle': 'Novelle',
    'eventyr': 'Eventyr',
    'fantasy': 'Fantasy',
    'dikt': 'Dikt',
    'sangtekst': 'Sangtekst',
    'fagartikkel': 'Fagartikkel',
    'saktekst': 'Saktekst',
    'debattinnlegg': 'Debattinnlegg',
    'nyhetsartikkel': 'Nyhetsartikkel',
    'reklame': 'Reklame',
    'some-innlegg': 'SoMe-innlegg',
    'tale': 'Tale',
    'appell': 'Appell',
    'roman': 'Roman',
    'lesetrening': 'Lesetrening',
    'detektiver og mysterier': 'Detektiver og mysterier',
    'leserinnlegg': 'Leserinnlegg',
    'vitser': 'Vitser',
    'krim': 'Krim',
    'science fiction': 'Science fiction',
    'humor': 'Humor',
    'lettlest': 'Lettlest',
    'spenning': 'Spenning',
    'sakprosa': 'Sakprosa',
  },
  copyright: {
    open: 'Åpne bildebeskrivelse',
    close: 'Lukk bildebeskrivelse',
    image: 'Bilde: {copyright}',
    animation: 'Animasjon: {copyright}',
  },
  embeds: {
    notSupported: 'Innebygd media er ikke støttet'
  },
  feedback: {
    question: 'Fant du det du lette etter?',
    positive: 'Tusen takk!',
    negative: 'Vi setter stor pris på tilbakemelding! Send gjerne en e-post til <a href="mailto:{email}" class="font-bold underline">{email}</a>. Husk å inkludere en kopi av adresselinjen.',
    copyUrl: 'Kopier adresselinjen',
    send: 'Send inn',
    event: {
      rated: 'Takk!',
      submit: 'Takk for tilbakemeldingen!',
      copied: 'Adresselinjen ble kopiert',
      copyFailed: 'Kunne ikke kopiere adresselinjen',
    }
  },
  vidstack: {
    'Caption Styles': 'Tekststiler',
    'Captions look like this': 'Teksting ser slik ut',
    'Closed-Captions Off': 'Teksting av',
    'Closed-Captions On': 'Teksting på',
    'Display Background': 'Vis bakgrunn',
    'Enter Fullscreen': 'Gå til fullskjerm',
    'Enter PiP': 'Gå til bilde i bilde',
    'Exit Fullscreen': 'Avslutt fullskjerm',
    'Exit PiP': 'Avslutt bilde i bilde',
    'Google Cast': 'Google Cast',
    'Keyboard Animations': 'Tastaturanimasjoner',
    'Seek Backward': 'Spol tilbake',
    'Seek Forward': 'Spol fremover',
    'Skip To Live': 'Hopp til direktesending',
    'Text Background': 'Tekstbakgrunn',
    'Accessibility': 'Tilgjengelighet',
    'AirPlay': 'AirPlay',
    'Announcements': 'Kunngjøringer',
    'Audio': 'Lyd',
    'Auto': 'Auto',
    'Boost': 'Forsterk',
    'Captions': 'Teksting',
    'Chapters': 'Kapitler',
    'Color': 'Farge',
    'Connected': 'Tilkoblet',
    'Connecting': 'Kobler til',
    'Continue': 'Fortsett',
    'Default': 'Standard',
    'Disabled': 'Deaktivert',
    'Disconnected': 'Frakoblet',
    'Download': 'Last ned',
    'Family': 'Familie',
    'Font': 'Skrift',
    'Fullscreen': 'Fullskjerm',
    'LIVE': 'DIREKTE',
    'Loop': 'Gjenta',
    'Mute': 'Demp',
    'Normal': 'Normal',
    'Off': 'Av',
    'Opacity': 'Gjennomsiktighet',
    'Pause': 'Pause',
    'PiP': 'Bilde i bilde',
    'Play': 'Spill av',
    'Playback': 'Avspilling',
    'Quality': 'Kvalitet',
    'Replay': 'Spill igjen',
    'Reset': 'Tilbakestill',
    'Seek': 'Søk',
    'Settings': 'Innstillinger',
    'Shadow': 'Skygge',
    'Size': 'Størrelse',
    'Speed': 'Hastighet',
    'Text': 'Tekst',
    'Track': 'Spor',
    'Unmute': 'Slå på lyd',
    'Volume': 'Volum',
  },
  subscription: {
    messages: {
      endDate: 'Lisensen på {name} utløper {date}',
      missing: 'Ingen abonnement',
      current: 'Du har følgende aktive abonnement:',
      upgrade: {
        fromBasic: 'Ved å oppgradere til PLUSS får hele skolen tilgang til Papir+ og Biblioteket.',
        fromPlus: '',
      },
      webshop: {
        internal: '<a href="https://skole.aschehoug.no" class="underline focus-visible:ring" target="_blank">skole.aschehoug.no</a>',
        external: '<a href="https://www.pendel.no/" class="underline focus-visible:ring" target="_blank">Pendel</a> eller <a href="https://skolon.no" class="underline focus-visible:ring" target="_blank">Skolon</a>',
      },
      readMore: 'Les mer om, og endre abonnementet her:',
    },
    application: 'Aunivers',
    name: {
      PrimaryTrial: 'Aunivers 1–7 Prøvelisens',
      PrimaryBasic: 'Aunivers 1–7 Basis',
      PrimaryIndividual: 'Aunivers 1–7 Individuell',
      PrimaryPlus: 'Aunivers 1–7 Pluss',
      PrimaryPremium: 'Aunivers 1–7 Premium',
      SecondaryTrial: 'Aunivers 8–10 Prøvelisens',
      SecondaryBasic: 'Aunivers 8–10 Basis',
      SecondaryIndividual: 'Aunivers 8–10 Individuell',
      SecondaryPlus: 'Aunivers 8–10 Pluss',
      SecondaryPremium: 'Aunivers 8–10 Premium',
      VgsTrial: 'Aunivers VGS Prøvelisens',
      VgsIndividual: 'Aunivers VGS Individuell',
    },
    type: {
      none: 'Ingen',
      trial: 'Prøve',
      individual: 'Individuell',
      basic: 'Basis',
      plus: 'Pluss',
      premium: 'Premium',
    }
  },
  validation: {
    general: {
      required: {
        error: 'Feltet må fylles ut',
      },
    },
    favorite: {
      name: {
        error: 'Navnefeltet kan bare inneholde tegn: a til å, 0 til 9 og utvalgte spesialtegn: {\'.\'}{\',\'}{\'@\'}{\'!\'}{\'?\'}{\'|\'}{\'§\'}{\'#\'}{\'<\'}{\'>\'}{\'[\'}{\']\'}{\'-\'}{\'+\'}\'{\'*\'}{\'"\'}{\'^\'}{\'`\'}{\':\'}{\';\'}{\'(\'}{\')\'}',
      },
      note: {
        error: 'Notatfeltet kan bare inneholde tegn: a til å, 0 til 9 og utvalgte spesialtegn: {\'.\'}{\',\'}{\'@\'}{\'!\'}{\'?\'}{\'|\'}{\'§\'}{\'#\'}{\'<\'}{\'>\'}{\'[\'}{\']\'}{\'-\'}{\'+\'}\'{\'*\'}{\'"\'}{\'^\'}{\'`\'}{\':\'}{\';\'}{\'(\'}{\')\'}',
      },
    },
  },
  flyt: {
    missingTranslationMessage: 'Vi arbeider med å få vist oppgavene våre på nynorsk!',
  },
  chatbot: {
    remember: 'Botten husker bare meldingene under',
    placeholder: 'Skriv her ...',
    answering: 'Chatbotten svarer',
    answered: 'Chatbotten har svart',
    answer: 'Svar fra chatbotten',
    message: 'Din melding',
    error: 'Noe gikk galt, vennligst prøv igjen',
    mathFormula: 'Sett inn formel',
    info: {
      title: 'Du snakker nå med en chatbot',
      heading: 'KI-oppgave i Aunivers',
      paragraph1: 'Dette er en oppgave som bruker kunstig intelligens (KI) for å hjelpe deg med å forstå og bruke fagstoff bedre. Verktøyet gir deg hjelp og veiledning, men løser ikke oppgavene for deg.',
      paragraph2: 'Læreren din kan ikke se hva du skriver eller gjør når du bruker dette verktøyet. Ingen av samtalene dine blir lagret.',
      paragraph3: 'Ettersom det er KI, kan det forekomme at den sier noe som er feil. Hvis du er i tvil, kan du sjekke med andre kilder.',
    },
    feedback: {
      title: 'Rapporter feil i chatbot',
      cta: 'Rapporter feil',
      message: 'Gjorde boten noe rart? Trykk på knappen for å sende inn loggen til oss, så hjelper du oss å gjøre den bedre.',
      disclaimer: 'Innsendingen er anonymisert.',
    },
  },
  assign: {
    share: 'Del',
    close: 'Steng',
    delete: 'Slett',
    shareWithStudents: 'Del med elever',
    goToExam: 'Gå til prøven',
    openTheExam: 'Åpne prøven',
    openingExam: 'Åpner prøven ...',
    closeTheExam: 'Steng prøven',
    closeForAll: 'Steng prøven for alle',
    closingExam: 'Stenger prøven ...',
    examClosed: 'Prøven er stengt',
    deleteExam: 'Slett prøven',
    deletingExam: 'Sletter prøven ...',
    deleteConfirm: 'Er du helt sikker på at du vil slette terminprøven: {name}?',
    locked: 'Låst',
    shared: 'Åpen',
    opened: 'Åpnet',
    closed: 'Stengt',
    editAccess: 'Rediger elevtilgang',
    noStudents: 'Fant ingen elever. Sørg for at du har skrevet riktig navn.',
    noStudentsInGroup: 'Fant ingen elever i gruppen',
    chooseAll: 'Velg alle',
    chooseGroup: 'Velg gruppe',
    chooseStudents: 'Velg elever',
    chooseStudentsAccess: 'Velg hvilke elever som skal få tilgang til terminprøven.',
    studentsAccessInfo: 'Elevene må ha logget inn i Aunivers tidligere for å vises i listen.',
    searchPlaceholder: 'Søk blant elevene ...',
    startExam: 'Start prøven nå',
    startingExam: 'Starter prøven ...',
    open: 'Åpne',
    closeExam: 'Steng prøve',
    createExam: 'Opprett prøve',
    creatingExam: 'Oppretter prøve ...',
    saveStudents: 'Lagre elevvalg',
    savingStudents: 'Lagrer elevvalg ...',
    createError: 'Noe gikk galt med å opprette prøven, vennligst prøv igjen eller kontakt kundeservice.',
    createInfo1: 'Du må opprette prøven før du kan dele den med de elevene du ønsker i valgt gruppe.',
    createInfo2: 'Frykt ikke, du kan trygt opprette prøven uten at den blir delt med elevene dine.',
    taskIsOpen: 'Terminprøven er åpen',
    taskIsClosed: 'Terminprøven er låst',
    taskStatusInfo: 'For at eleven skal få tilgang til terminprøven må prøven og elevens status være satt til åpen.',
    error: 'Noe gikk galt.',
    planned: 'Planlagte prøver',
    noTasks: 'Du har ikke opprettet noen terminprøver',
    noTasksInfo1: 'Når du har opprettet en prøve, kan du dele den med elever.',
    noTasksInfo2: 'Sørg for at læreren som skal dele prøven med elevene på prøvedagen, er medlem i gruppa.',
    confirm: 'Bekreft valg',
    confirmInfo: 'Er du sikker på at du vil {status} prøven for {student}?',
    confirmClose: 'Stenge',
    searchForStudents: 'Søk etter elever',
    searchForStudentsTip: 'Søkeordet må ha minst 3 tegn',
    missingStudents: 'Mangler det noen elever?',
    searchSchoolPlaceholder: 'Søk blant elevene på skolen ...',
    studentAdded: 'Lagt til',
    addStudents: 'Legg til elever',
    closedFor: 'Prøven er <b>stengt</b> for:',
    openFor: 'Prøven er <b>åpen</b> for:',
    seeExam: 'Se prøven',
    seeAndCreate: 'Se og opprett',
    seeAndEdit: 'Se, tilpass og opprett',
    tasks: 'Oppgaver',
    chooseTask: 'Velg denne oppgaven',
    taskChosen: 'Oppgave valgt',
    toasts: {
      createSuccess: 'Prøven ble opprettet',
      createError: 'Noe gikk galt med å opprette prøven',
      deleteSuccess: 'Prøven ble slettet',
      deleteError: 'Noe gikk galt med å slette prøven',
      openSuccess: 'Prøven ble åpnet',
      openError: 'Noe gikk galt med å åpne prøven',
      closeSuccess: 'Prøven ble stengt',
      closeError: 'Noe gikk galt med å stenge prøven',
      saveSuccess: 'Prøven ble lagret',
      saveError: 'Noe gikk galt med å lagre prøven',
      addUsersAndOpenSuccess: 'Terminprøven ble åpnet og delt med elevene',
      addUsersAndOpenError: 'Noe gikk galt med å åpne terminprøven og dele med elevene',
      updateUserSuccess: 'Prøven ble {status} for {user}',
      updateUserError: 'Noe gikk galt med å endre status for {user}',
    },
    student: {
      infoTitle: 'Akkurat nå har du ingen tildelte terminprøver',
      infoMessage: 'Når læreren din deler en terminprøve med deg, vil den dukke opp her!',
      noTasksFound: 'Fant ingen oppgaver'
    },
    upcoming: {
      autumnTitle: 'Høstens terminprøver',
      springTitle: 'Vårens terminprøver',
      unknownDate: 'Terminprøvene er ikke tilgjengelige.',
    },
    placeholders: {
      chooseGroup: 'Velg gruppe',
      chooseSchoolYear: 'Velg skoleår',
      chooseGrade: 'Velg trinn',
      chooseSubject: 'Velg fag',
    },
  },
  termExam: {
    title: 'Terminprøve',
    byline: 'Terminprøve { title }',
    group: 'Gruppe: <b>{ groupName }</b>',
    earlier: 'Tidligere prøver',
    earlierDescription: 'Her finner du tidligere terminprøver som elevene kan bruke til å øve. Disse har ikke samme funksjonalitet som de aktive terminprøvene. De kan ikke tildeles og er ikke selvrettende.',
    others: 'Innhold',
    missing: 'Ingen oppgaver tilgjengelig',
  },
  report: {
    title: 'Rapporter',
    button: 'Rapport',
    submissions: 'Innleveringer',
    result: 'Resultat',
    errorLoadingData: 'Noe gikk galt med å hente rapportdata, prøv igjen.',
    exam: {
      title: 'Terminprøver',
      tooltip: {
        open: 'Her finner du rapporter for terminprøvene',
        close: 'Tilbake til prøvene',
      },
      noResults: {
        title: 'Ingen resultater',
        message: 'Har du valgt riktig gruppe og trinn?',
      }
    },
    banner: {
      title: 'Rapport',
      description: 'Terminprøve {season} {year}',
      responseRate: 'Svarprosent: ',
      total: 'Totalresultat',
      group: 'Gruppe: ',
    },
    toolbar: {
      missing: 'Vennligst velg:',
      groupDropdown: 'Gruppe',
      subjectDropdown: 'Fag',
      gradeDropdown: 'Trinn',
      weekDropdown: 'Uke',
      contextDropdown: 'Tema',
      gradeTypeDropdown: 'Skoleslag',
      intervalDropdown: 'Intervall',
    },
    interval: {
      '1w': 'En uke',
      '3m': 'Tre mnd.',
      '6m': 'Seks mnd.',
      'start': 'Skolestart'
    },
    status: {
      correct: 'riktig',
      wrong: 'feil',
      unanswered: 'ubesvart',
    },
    studentList: {
      name: 'Navn',
      result: 'Resultat',
    },
    messages: {
      notStarted: 'Ikke påbegynt',
      toAnswer: 'Gå til besvarelse',
      baseFilter: 'Juster filter for å se rapport',
      error: {
        title: 'Noe gikk galt',
        message: 'Her gikk noe galt. Prøv igjen senere.',
      },
      missingFilters: {
        title: 'Velg gruppe og trinn',
        message: 'Både gruppe og trinn må være valgt',
      },
      missingGroup: {
        title: 'Velg gruppe',
        message: 'Velg en gruppe for å se rapporter',
      },
      noResults: 'Ingen resultater funnet',
    },
    season: {
      spring: 'vår',
      autumn: 'høst',
    },
    actions: {
      goToFormWriter: 'Gå til innleveringsrammen',
      goToFlytTask: 'Gå til oppgaven',
    },
  },
  sources: {
    showSources: 'Vis kilder',
    sources: 'Kilder',
  },
  reportFeedback: {
    button: 'Gi tilbakemelding',
    placeholder: '// Skriv din tilbakemelding her',
    subject: 'Tilbakemelding: {title}',
    url: 'Tilbakemeldingen gjelder innholdet på {url}.',
    intro: 'Til redaksjonen i Aschehoug,',
    organization: 'Jeg tilhører {name} ({number}).'
  },
  model3d: {
    touch: 'Touch',
    mouse: 'Mus',
    keyboard: 'Tastatur',
    touchRotate: 'En finger for å rotere.',
    touchMove: 'To fingre for å flytte.',
    touchZoom: 'Klyp for å zoome.',
    mouseRotate: 'Hold inne venstre museknapp for å rotere.',
    mouseMove: 'Hold inne høyre museknapp for å flytte.',
    mouseZoom: 'Scroll hjulet på musen for å zoome.',
    keyboardRotate: 'Piltaster for å rotere.',
    keyboardMove: 'Alt (Windows) / Option (Mac) + piltaster for å flytte.',
    keyboardZoom: '+ for å zoome inn og − for å zoome ut.',
  },
  scene: {
    reset: 'Slett alt i scenen',
    resetConfirm: 'Bekreft',
    resetText: 'Dette vil nullstille scenen til sånn den opprinnelig var.',
    delete: 'Slett',
    dragDelete: 'Dra hit for å slette',
    clone: 'Klon',
    keyboard: 'Tastatur',
    keyboardMove: 'Piltaster for å flytte.',
    keyboardResize: '+ for å forstørre og - for å forminske.',
    keyboardRotate: 'J og K for å rotere',
    settings: 'Instillinger',
    showMeasurements: 'Vis mål',
  },
  share: {
    title: 'Del',
    edit: 'Rediger tildeling',
    list: 'Liste',
    viewAll: 'Se alle',
    placeholders: {
      messageField: 'Skriv her...',
    },
    options: {
      now: 'Del nå',
      time: 'Velg tidspunkt',
      homework: 'Lekse',
    },
    messages: {
      share: 'Del',
      shareList: 'Del listen',
      shareResource: 'Del ressursen',
      sharing: 'Deler',
      edit: 'Rediger',
      save: 'Lagre',
      saving: 'Lagrer...',
      optionalMessage: 'Valgfri melding',
      resource: 'Ressurs',
      list: 'Liste',
      homework: 'Marker som lekse',
      recent: 'Siste fra lærer',
      future: 'Valgt tidspunkt må være i fremtiden',
    },
    toasts: {
      createError: 'Kunne ikke dele',
      createSuccess: 'Innhold delt'
    },
    teacher: {
      short: 'Kun synlig for lærere',
      title: 'Elever vil ikke se lærerinnhold',
      message: 'Ressursen du ønsker å dele er kun synlig for lærer. Elever du deler ressursen med vil ikke se den.',
      list: 'Ressursen er kun synlig for lærere. Elever du deler listen med vil ikke se denne ressursen.',
    },
  },
  shared: {
    week: 'Uke {weekNumber}',
    empty: 'Her var det tomt!',
    goToList: 'Gå til liste',
    goToResource: 'Gå til ressurs',
    list: 'Liste',
    message: 'Melding:',
    noMessage: 'Ingen melding',
    sharedWith: 'Delt med',
    deleteShared: 'Slett tildeling',
    latestFromTeacher: 'Siste fra lærer',
    allFromTeacher: 'Alt fra lærer',
    toasts: {
      updated: 'Tildelingen ble oppdatert'
    },
    students: '{n} elev | {n} elever',
    teachers: '{n} lærer | {n} lærere',
  },
  myContent: {
    title: 'Mitt innhold',
    lists: 'Mine lister',
    shared: 'Delt av meg',
    reports: 'Rapporter og innleveringer',
    studentTitle: 'Fra lærer',
    studentDescription: 'Her ser du innhold som læreren har delt med deg',
  },
  formWriter: {
    error: 'Noe gikk galt med å hente skjemaet, vennligst prøv igjen.',
    uploadImage: 'Last opp et bilde',
    imageTeacher: 'Her kan elevene legge til et bilde',
    uploadingImage: 'Laster opp bilde ...',
    deleteImage: 'Slett bilde',
    downloadImage: 'Last ned bilde',
    uploadFile: 'Last opp fil',
    chooseImage: 'Velg et bilde fra listen til høyre',
    chooseOrUploadImage: 'Velg et bilde fra listen til høyre, eller last opp et bilde her:',
    submit: 'Send til lærer',
    downloadWord: 'Last ned Word-dokument',
    downloadPdf: 'Last ned PDF',
    delivered: 'Innleveringer',
    delete: 'Slett',
    download: 'Last ned',
    downloading: 'Laster ned ...',
    fileTeacher: 'Filen eleven har levert:',
    fileStudent: 'Filen du har levert til læreren din:',
    uploading: 'Laster opp...',
    upload: 'Last opp',
    loading: 'Laster...',
    confirmLeave: 'Skjemaet har endringer som ikke er lagret. Er du sikker?',
    saveReminder1: 'Husk å sende innholdet til læreren.',
    saveReminder2: 'Husk å sende innholdet til læreren på nytt.',
    saveConfirmation: 'Innholdet er sendt til læreren.',
    draft: 'Utkast',
    wordCount: '{count} ord',
    wordLimitReached: 'Maksgrensen på {max} ord er nådd',
    tooltips: {
      label: 'Vis/skjul etikett',
      description: 'Vis/skjul hjelpetekst',
      placeholder: 'Vis/skjul plassholder',
      modelText: 'Vis/skjul modelltekst',
      image: 'Last opp et bilde',
      print: 'Skriv ut',
      download: 'Nedlastingsvalg',
      chooseImage: 'Velg bilde',
    },
    labels: {
      group: 'Klasse/gruppe',
      visited: 'Besøkt ({number})',
      notVisited: 'Ikke besøkt ({number})',
      chooseStudent: 'Velg elev',
      noStudents: 'Ingen elever',
      showStudents: 'Vis elever',
      chooseVersion: 'Velg versjon',
      noVersions: 'Ingen versjoner',
    },
    toasts: {
      submitSuccess: 'Innholdet ble levert!',
      submitError: 'Noe gikk galt med å levere teksten, vennligst prøv igjen.',
      fileDownloadError: 'Noe gikk galt med å laste ned filen. Vennligst prøv igjen',
      fileDownloadSuccess: 'Filen ble lastet ned',
      nothingToExport: 'Ingenting å eksportere',
      imageUpload: 'Bildet ble lastet opp!',
      imageUploadError: 'Noe gikk galt med å laste opp bildet, vennligst prøv igjen',
      missingRecordingError: 'Opptaket er tomt eller ikke tilgjengelig',
      missingFileError: 'Ressursen er tom eller ikke tilgjengelig',
    },
    callouts: {
      missingMethods: 'Ingen innleveringsmetoder tilgjengelig enda',
      missingAssignment: 'Innholdet ditt i feltene nedenfor er kun synlig for deg',
      versionLimitReached: 'Maksgrensen på 100 versjoner per innlevering er nådd',
      missingGroups: 'For å se innhold fra elevene må du være tilknyttet en eller flere grupper.',
      viewingPreviousVersion: 'Du ser på en tidligere versjon. Du kan ikke redigere innhold eller sende inn når du ser på tidligere versjoner.',
    },
    placeholders: {
      imageUpload: 'Her kan eleven laste opp et bilde',
      audioRecording: 'Her kan eleven spille inn et lydopptak',
      fileUpload: 'Her kan eleven laste opp en fil',
    },
  },
  tts: {
    voice: 'KI-stemme',
    warning: 'Stemmen som leser denne artikkelen er laget ved hjelp av kunstig intelligens (KI)',
    missingText: 'Ingen tekst funnet',
    generateError: 'Feil ved avspilling. Prøv igjen senere.',
  },
  reports: {
    activities: 'Aktiviteter',
    noAssignmentData: 'Ingen oppgavedata tilgjengelig',
    formwriter: {
      delivered: 'Levert',
      inProgress: 'Påbegynt',
      notDelivered: 'Ikke levert',
      student: 'Elev',
      activity: 'Aktivitet',
      name: 'Navn',
      status: 'Status',
      lastActivity: 'Siste aktivitet',
    },
    filters: {
      all: 'Alle',
      completed: 'Fullført',
      started: 'Påbegynt',
      notStarted: 'Ikke påbegynt',
    },
    breadcrumb: {
      aria: 'Rapportnavigasjon',
      main: 'Aktiviteter',
      sep: ' / ',
      activityFallback: 'Aktivitet',
    },
    details: {
      activityDetails: 'Aktivitetsdetaljer',
      taskDetails: 'Oppgavedetaljer',
      timestamp: 'Tidsstempel',
      duration: 'Varighet',
      score: 'Poengsum',
      user: 'Bruker',
      taskResults: 'Oppgaveresultater',
      taskItem: 'Oppgave',
      submittedAt: 'Levert',
      studentInfo: 'Elevinfo',
      name: 'Navn',
      totalScore: 'Total poengsum',
      individualResults: 'Individuelle resultater',
      taskInfo: 'Oppgaveinformasjon',
      title: 'Tittel',
    },
    status: {
      correct: 'Riktig',
      partiallyCorrect: 'Delvis riktig',
      incorrect: 'Feil',
      notSubmitted: 'Ikke levert',
      notStarted: 'Ikke påbegynt',
      started: 'Påbegynt',
      completed: 'Fullført',
      partiallyCompleted: 'Delvis fullført',
      passed: 'Bestått',
      failed: 'Ikke bestått',
      partiallyPassed: 'Delvis bestått',
      noData: 'Ingen data',
      unknown: 'Ukjent status',
      notParticipated: 'Ikke deltatt',
      notCompleted: 'Ikke fullført',
    },
    state: {
      retry: 'Prøv igjen',
      loading: 'Laster',
      error: {
        load: {
          title: 'Noe gikk galt',
          message: 'Vi klarte ikke å hente rapportdataene. Vennligst prøv igjen senere.',
        },
        empty: {
          title: 'Ingen rapportdata',
          message: 'Det finnes ingen rapportdata for de valgte filtrene. Prøv med andre filtre.',
        }
      }
    },
    result: {
      single: 'resultat',
      plural: 'resultater',
    },
    titles: {
      activity: 'Aktivitet',
    },
    pagination: {
      title: 'Paginering',
      page: 'Side',
      previous: 'Forrige',
      next: 'Neste',
    },
    sort: {
      aToZ: 'A–Z',
      zToA: 'Z–A',
      oldest: 'Eldst',
      newest: 'Nyest',
      sortMode: 'Sorteringsmodus',
      viewMode: 'Visningsmodus',
      pagination: 'Paginering',
      list: 'Liste',
      grid: 'Rutenett',
      title: 'Sortering',
      byTime: 'Sorter på tid',
      newestFirst: 'Nyeste først',
      oldestFirst: 'Eldste først',
    },
    sidebar: {
      ariaLabel: 'Filter for rapporter',
      title: 'Filter',
      group: 'Gruppe',
      subject: 'Fag',
      gradeType: 'Skoleslag',
      user: 'Bruker',
      type: 'Type',
      period: 'Periode',
      allSubjects: 'Alle fag',
      allTypes: 'Alle typer',
      allPeriods: 'Alle perioder',
      allGradeTypes: 'Alle skoleslag',
      all: 'Alle',
      sections: {
        groupUser: 'Gruppe og bruker',
        content: 'Innhold',
        school: 'Skole',
      },
    },
    types: {
      activity: 'Aktivitet',
      task: 'Oppgave',
      assignment: 'Innlevering',
    },
    statusFilters: {
      all: 'Alle',
      completed: 'Fullført',
      started: 'Påbegynt',
      notStarted: 'Ikke påbegynt',
    },
    metrics: {
      completion: 'Gjennomføring',
      understanding: 'Forståelse',
      engagement: 'Engasjement',
      assignments: 'Innleveringer:',
      tasks: 'Riktige oppgaver:',
      visits: 'Besøk:',
      completedTasksAndAssignments: 'Fullførte oppgaver og innleveringer',
      visitedArticle: 'Besøkt artikkel',
    },
    periods: {
      schoolYear: 'Skoleår',
      autumn: 'Høstsemester',
      spring: 'Vårsemester',
      last30: 'Siste 30 dager',
      last7: 'Siste 7 dager',
      today: 'I dag',
    },
    tabs: {
      overview: 'Oversikt',
      activities: 'Aktiviteter',
      visits: 'Besøk',
      task: 'Oppgave',
      assignment: 'Innlevering',
    },
    viewModes: {
      rows: 'Rader',
      table: 'Tabell',
    },
    overview: {
      completedTasks: 'Fullførte oppgaver',
      needsAssistance: 'Trenger hjelp',
      noActivity: 'Ingen aktivitet',
      timeSpent: 'Tidsbruk',
      timeSpentAverage: 'Average time: 30m 47s'
    },
    table: {
      headers: {
        name: 'Navn',
        progression: 'Progresjon',
        lastVisited: 'Sist besøkt'
      },
      scrollHint: 'Rull sidelengs for å se alle oppgaver'
    },
    labels: {
      visited: 'Besøkt ({number})',
      visitCount: 'Besøkt: {visited} av {total}',
      visitedAt: 'Besøkt: {timestamp}',
      visitStatus: 'Besøkt:',
      visitedTitle: 'Besøkt',
      notVisitedTitle: 'Ikke besøkt'
    },
    content: {
      meta: {
        type: 'Type',
        published: 'Publisert',
        parent: 'Forelder',
        grades: 'Trinn',
        contentId: 'Innholds-ID',
        locationId: 'Plassering-ID',
      },
    },
    tasks: {
      passed: 'Riktig',
      unanswered: 'Ubesvart',
      failed: 'Feil',
      completed: 'Fullført',
      started: 'Påbegynt',
      notStarted: 'Ikke påbegynt',
      combinedOverview: 'Sammendrag',
      totalStudents: 'Antall elever',
      avgScore: 'Snittscore',
      totalAttempts: 'Antall forsøk',
      perStudent: 'Per elev',
      attempts: 'Forsøk',
      item: 'Oppgave',
      task: 'Oppgave',
      tasks: 'Oppgaver',
      timeUsed: 'Tid brukt',
      lastChanged: 'Sist endret',
    },
    task: {
      article: 'Artikkel',
      taskSet: 'Oppgavesett',
      progression: 'Progresjon',
      taskItem: 'Oppgave',
      attempts: 'Forsøk',
      time: 'Tid',
      score: 'Poeng',
    },
    noTaskData: 'Ingen oppgavedata tilgjengelig',
    errors: {
      notFound: 'Fant ingen aktivitet',
      notWorking: 'Kunne ikke laste rapport',
    },
  },
  status: {
    notStarted: 'Ikke påbegynt',
    inProgress: 'Pågår',
    completed: 'Fullført',
  },
  component: {
    openTask: 'Oppgave',
    openActivity: 'Aktivitet',
    openFormWriter: 'Innlevering',
  },
  type: 'Type',
  score: 'Score',
  percent: 'Prosent',
  digitalBook: {
    title: 'Digital bok',
  },
}

export default nb
